(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
function initMomentFooter(root) {
 if (!root || root.dataset.footerReady) return;
 root.dataset.footerReady = 'true';
 const desktop = window.matchMedia('(min-width:700px)');
 const groups = root.querySelectorAll('.moment-footer__group');
 function setGroups() { groups.forEach(function(group) { group.open = desktop.matches; }); }
 setGroups();
 desktop.addEventListener('change', setGroups);
}
document.querySelectorAll('.moment-footer').forEach(initMomentFooter);
document.addEventListener('shopify:section:load', function(event) { event.target.querySelectorAll('.moment-footer').forEach(initMomentFooter); });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
function initMomentCatalog(root){
  if(!root || root.dataset.initialized)return;
  root.dataset.initialized='true';
  const links=[...root.querySelectorAll('[data-group]')];
  const description=root.querySelector('[data-catalog-description]');
  const current=links.find(link=>link.hasAttribute('aria-current'));
  if(current)description.textContent=current.dataset.description;
  if(!root.hasAttribute('data-all-catalog') || !root.querySelector('[data-single-page]'))return;
  const cards=[...root.querySelectorAll('[data-memberships]')];
  const count=root.querySelector('[data-catalog-count]');
  const empty=root.querySelector('[data-catalog-empty]');
  function apply(group){
    const selected=links.find(link=>link.dataset.group===group)||links[0];
    let visible=0;
    cards.forEach(card=>{card.hidden=selected.dataset.group!=='all'&&!card.dataset.memberships.split(' ').includes(selected.dataset.group);if(!card.hidden)visible++;});
    links.forEach(link=>{if(link===selected)link.setAttribute('aria-current','page');else link.removeAttribute('aria-current');});
    description.textContent=selected.dataset.description;
    count.textContent=count.dataset.countTemplate.replace('__COUNT__',visible);
    empty.hidden=visible!==0;
  }
  apply(new URL(location.href).searchParams.get('collezione')||'all');
  links.forEach(link=>link.addEventListener('click',event=>{
    if(event.ctrlKey||event.metaKey||event.shiftKey||event.altKey||event.button!==0)return;
    event.preventDefault();
    const url=new URL(location.href);
    if(link.dataset.group==='all')url.searchParams.delete('collezione');else url.searchParams.set('collezione',link.dataset.group);
    history.pushState(null,'',url);
    apply(link.dataset.group);
  }));
  window.addEventListener('popstate',()=>apply(new URL(location.href).searchParams.get('collezione')||'all'));
}
document.querySelectorAll('.moment-catalog').forEach(initMomentCatalog);
document.addEventListener('shopify:section:load',event=>{if(event.target.matches('.moment-catalog'))initMomentCatalog(event.target);else event.target.querySelectorAll('.moment-catalog').forEach(initMomentCatalog);});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
document.querySelectorAll('[data-product-purchase-bar]').forEach(function(bar) {
 const button = document.querySelector('[data-product-submit]');
 const price = document.querySelector('[data-product-price]');
 if (!button || !price) return;
 document.body.classList.add('has-product-purchase-bar');
 const stickyPrice = bar.querySelector('[data-sticky-price]');
 function syncPrice() { stickyPrice.textContent = price.textContent.trim(); }
 syncPrice();
 new MutationObserver(syncPrice).observe(price, {childList: true, subtree: true, characterData: true});
 let buttonVisible = false;
 function updateBar() { bar.hidden = window.innerWidth >= 900 || window.scrollY < 80 || buttonVisible || button.disabled; }
 new IntersectionObserver(function(entries) { buttonVisible = entries[0].isIntersecting; updateBar(); }).observe(button);
 window.addEventListener('scroll', updateBar, {passive:true});
 window.addEventListener('resize', updateBar);
 updateBar();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search"]) return;
  try {
    
(() => {
  const form = document.querySelector('[data-moment-search-form]');
  if (!form) return;
  const input = form.querySelector('[name="q"]');
  const url = new URL(window.location.href);
  const rawQuery = url.searchParams.get('q') || '';
  const original = url.searchParams.get('query');
  const scoped = rawQuery.startsWith('(title:"');
  if (scoped && original) {
    input.value = original;
    const summary = document.querySelector('[data-search-summary]');
    if (summary) summary.textContent = summary.dataset.format.replace('__moment_query__', original);
  }
  if (scoped) document.title = document.title.replaceAll(rawQuery, original || input.value);
  const stopWords = new Set(['a', 'ad', 'al', 'alla', 'alle', 'allo', 'ai', 'agli', 'da', 'dal', 'dalla', 'dalle', 'dei', 'del', 'della', 'delle', 'di', 'e', 'ed', 'i', 'il', 'in', 'l', 'la', 'le', 'lo', 'per', 'un', 'una', 'uno', 'con', 'chi', 'ama', 'che']);
  const fields = ['title', 'tag', 'product_type', 'variants.title'];
  // Expand customer vocabulary to existing catalog tags, without searching generic descriptions.
  const tagGroups = [
    ['love', 'amore', 'coppia', 'fidanzato', 'fidanzata', 'fidanzati', 'partner', 'marito', 'moglie', 'innamorati'],
    ['family', 'famiglia', 'famiglie', 'familiare', 'familiari'],
    ['mamma', 'mamme', 'madre', 'madri'],
    ['papa', 'papà', 'padre', 'padri'],
    ['neo-papa', 'neopapa', 'neopapà'],
    ['nonna', 'nonne'],
    ['figli', 'figlio', 'figlia', 'figlie'],
    ['sorelle', 'sorella'],
    ['ironia-fratelli', 'fratello', 'fratelli'],
    ['amicizia', 'amico', 'amica', 'amici', 'amiche'],
    ['colleghi', 'collega', 'colleghe'],
    ['insegnanti', 'insegnante', 'maestra', 'maestro', 'maestre', 'maestri', 'professore', 'professoressa', 'professori'],
    ['you', 'incoraggiamento', 'motivazione', 'motivazionale'],
    ['animali', 'animale'],
    ['cani', 'cane', 'cagnolino', 'cagnolini'],
    ['gatti', 'gatto', 'gatta', 'gattino', 'gattini', 'micio'],
    ['sport', 'sportivo', 'sportiva', 'sportivi'],
    ['arrampicata', 'scalata', 'climbing', 'arrampicatore'],
    ['arti-marziali', 'arti', 'marziali'],
    ['basket', 'pallacanestro', 'basketball'],
    ['boxe', 'pugilato', 'pugile'],
    ['calcio', 'calciatore', 'calciatrice', 'calciatori'],
    ['ciclismo', 'ciclista', 'ciclisti', 'bicicletta', 'bici'],
    ['corsa', 'running', 'correre', 'runner', 'corridore', 'corridori'],
    ['danza', 'ballo', 'ballerina', 'ballerino', 'ballerini'],
    ['trekking', 'escursionismo', 'escursioni', 'escursionista'],
    ['equitazione', 'cavallo', 'cavalli', 'cavaliere', 'amazzone'],
    ['fitness', 'palestra', 'allenamento', 'bodybuilding'],
    ['padel', 'padelista'],
    ['pallavolo', 'volley', 'pallavolista'],
    ['sci', 'sciatore', 'sciatrice', 'sciare'],
    ['surf', 'surfista'],
    ['hobby', 'passione', 'passioni'],
    ['canto', 'cantante', 'cantare'],
    ['ceramica', 'ceramista'],
    ['chitarra', 'chitarrista'],
    ['fotografia', 'fotografo', 'fotografa', 'fotografi'],
    ['lettura', 'libro', 'libri', 'lettore', 'lettrice', 'leggere'],
    ['motociclismo', 'moto', 'motociclista', 'motociclisti', 'biker'],
    ['pesca', 'pescatore', 'pescatrice', 'pescatori'],
    ['pittura', 'pittore', 'pittrice', 'dipingere'],
    ['uncinetto', 'crochet'],
    ['auto', 'automobile', 'automobili', 'automobilismo'],
    ['anime', 'cyberpunk'],
    ['ironia', 'ironico', 'ironica', 'ironici', 'divertente', 'divertenti'],
    ['caffe', 'caffè'],
    ['portachiavi', 'portachiave'],
    ['regalo', 'regali'],
    ['colore:rosso', 'rosso', 'rossa', 'red'],
    ['colore:bianco', 'bianco', 'bianca', 'white'],
    ['colore:rosa', 'rosa', 'pink'],
    ['colore:blu', 'blu', 'blue'],
    ['colore:giallo', 'giallo', 'gialla', 'yellow'],
    ['colore:verde', 'verde', 'green'],
    ['colore:corallo', 'corallo', 'coral']
  ];
  const tagAliases = new Map();
  tagGroups.forEach(([tag, ...aliases]) => [tag, ...aliases].forEach(alias => tagAliases.set(alias, tag)));
  const compile = text => {
    const words = [...new Set((text.trim().toLocaleLowerCase().replace(/'/g, '’').match(/[\p{L}\p{N}]+(?:’[\p{L}\p{N}]+)*/gu) || []).filter(word => !stopWords.has(word)))];
    if (!words.length) return '';
    return words.map(word => {
      const clauses = fields.map(field => field + ':"' + word + '"');
      const tag = tagAliases.get(word);
      if (tag && tag !== word) clauses.push('tag:"' + tag + '"');
      return '(' + clauses.join(' OR ') + ')';
    }).join(' AND ');
  };
  form.addEventListener('formdata', event => {
    const text = input.value.trim();
    const query = compile(text);
    event.formData.set('q', query || text);
    event.formData.set('query', text);
    event.formData.set('type', 'product');
  });
  // Apply the same focused matching to bookmarks and links containing an ordinary search.
  if (rawQuery.trim() && !scoped) {
    const query = compile(rawQuery);
    if (query) {
      url.searchParams.set('q', query);
      url.searchParams.set('query', rawQuery);
      url.searchParams.delete('page');
      window.location.replace(url.toString());
    }
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["moments-home-hero-v2"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function(event) {
 const trigger = event.target.closest('[data-open-moments-video]');
 if (!trigger) return;
 const details = document.getElementById('MomentsVideo');
 if (details) { details.open = true; const video = details.querySelector('video'); if (video) video.play().catch(function() {}); }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["moments-home-video"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.mv-video').forEach(function(details) {
 const video = details.querySelector('video');
 details.querySelector('summary').addEventListener('click', function() {
  if (!details.open) video.play().catch(function() {}); else video.pause();
 });
 details.addEventListener('toggle', function() { if (!details.open) video.pause(); });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["moments-phone-guide"] && !Shopify.designMode) return;
  try {
    
function initMomentNfcFinders(scope) {
 scope.querySelectorAll('[data-nfc-finder]').forEach(function(root) {
  if (root.dataset.nfcReady) return;
  root.dataset.nfcReady = 'true';
  const select = root.querySelector('[data-nfc-select]');
  const result = root.querySelector('[data-nfc-result]');
  const name = root.querySelector('[data-nfc-name]');
  const img = root.querySelector('[data-nfc-samsung-image], [data-nfc-official-image]');
  const error = root.querySelector('[data-nfc-image-error]');
  if (img) {
   img.addEventListener('error', function() { img.hidden = true; error.hidden = false; });
   img.addEventListener('load', function() { img.hidden = false; error.hidden = true; });
  }
  select.addEventListener('change', function() {
   const option = select.selectedOptions[0];
   if (select.value === '') {
    result.hidden = true;
    if (img) { img.removeAttribute('src'); img.hidden = true; }
    return;
   }
   result.hidden = false;
   name.textContent = option.textContent;
   if (root.dataset.nfcKind === 'apple') {
    root.querySelectorAll('[data-nfc-state]').forEach(function(el) { el.hidden = el.dataset.nfcState !== option.dataset.state; });
    root.querySelector('[data-nfc-apple-art]').hidden = option.dataset.state === 'unsupported';
   } else if (root.dataset.nfcKind === 'samsung') {
    error.hidden = true;
    img.hidden = true;
    img.alt = option.dataset.alt;
    img.src = option.dataset.image;
   } else {
    const state = option.dataset.status;
    root.querySelectorAll('[data-nfc-android-state]').forEach(function(el) { el.hidden = el.dataset.nfcAndroidState !== state; });
    root.querySelector('[data-nfc-position]').textContent = option.dataset.position || '';
    const diagramPosition = root.querySelector('[data-nfc-diagram-position]');
    if (diagramPosition) diagramPosition.textContent = option.dataset.position || '';
    const imageLink = root.querySelector('[data-nfc-image-link]');
    if (imageLink) {
     imageLink.hidden = state !== 'diagram';
     if (state === 'diagram') imageLink.href = option.dataset.image;
     else imageLink.removeAttribute('href');
    }
    root.querySelector('[data-nfc-visual]').hidden = state !== 'known' && state !== 'diagram';
    root.querySelectorAll('[data-nfc-shape]').forEach(function(el) { el.hidden = el.dataset.nfcShape !== option.dataset.shape; });
    const source = root.querySelector('[data-nfc-model-source]');
    source.href = option.dataset.source;
    source.hidden = false;
    if (img) {
     error.hidden = true;
     img.hidden = true;
     if (state === 'diagram') {
      img.alt = option.dataset.alt;
      img.src = option.dataset.image;
     } else {
      img.removeAttribute('src');
     }
    }
   }
  });
 });
}
initMomentNfcFinders(document);
document.addEventListener('shopify:section:load', function(event) { initMomentNfcFinders(event.target); });

function normalizeMomentPhoneName(value) {
 return value.normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/\b(apple|samsung|google)\b/g, '').replace(/\+/g, 'plus').replace(/[^a-z0-9]/g, '');
}
function matchMomentPhoneOptions(options, query) {
 const needle = normalizeMomentPhoneName(query);
 return options.filter(function(option) { return normalizeMomentPhoneName(option.text).includes(needle); });
}
function initMomentPhoneHierarchy(scope) {
 scope.querySelectorAll('[data-nfc-guide]').forEach(function(guide) {
  if (guide.dataset.hierarchyReady) return;
  guide.dataset.hierarchyReady = 'true';
  const brandSelect = guide.querySelector('[data-nfc-brand-select]');
  const brands = Array.from(guide.querySelectorAll('[data-nfc-brand]'));
  const combos = [];
  function closeOutside(event) {
   combos.forEach(function(combo) { if (!combo.field.contains(event.target)) combo.close(); });
  }
  function releaseOutside(event) { combos.forEach(function(combo) { combo.release(event); }); }
  function cleanup(event) {
   if (!event.target.contains(guide)) return;
   document.removeEventListener('pointerdown', closeOutside);
   document.removeEventListener('pointerup', releaseOutside);
   document.removeEventListener('pointercancel', releaseOutside);
   document.removeEventListener('shopify:section:unload', cleanup);
  }
  document.addEventListener('pointerdown', closeOutside);
  document.addEventListener('pointerup', releaseOutside);
  document.addEventListener('pointercancel', releaseOutside);
  document.addEventListener('shopify:section:unload', cleanup);
  guide.querySelector('[data-nfc-brand-controls]').hidden = false;
  guide.classList.add('mnfc-enhanced');
  function showBrand() {
   brands.forEach(function(panel) {
    panel.hidden = panel.dataset.nfcBrand !== brandSelect.value;
    if (!panel.hidden) panel.open = true;
   });
   guide.querySelectorAll('[data-nfc-finder]').forEach(function(root) {
    root.dispatchEvent(new Event('moment:nfc-close'));
   });
  }
  brandSelect.addEventListener('change', showBrand);
  showBrand();
  guide.querySelectorAll('[data-nfc-finder]').forEach(function(root) {
   const select = root.querySelector('[data-nfc-select]');
   const input = root.querySelector('[data-nfc-search]');
   const count = root.querySelector('[data-nfc-count]');
   const empty = root.querySelector('[data-nfc-empty]');
   const row = root.querySelector('[data-nfc-search-row]');
   const options = Array.from(select.options).slice(1).map(function(option, index) {
    return {text: option.textContent.trim(), value: option.value, index: index};
   });
   const field = document.createElement('div');
   field.className = 'mnfc-combo';
   input.parentNode.insertBefore(field, input);
   field.appendChild(input);
   input.type = 'text';
   input.setAttribute('role', 'combobox');
   input.setAttribute('aria-autocomplete', 'list');
   input.setAttribute('aria-expanded', 'false');
   input.setAttribute('aria-haspopup', 'listbox');
   input.setAttribute('autocapitalize', 'none');
   input.setAttribute('spellcheck', 'false');
   const list = document.createElement('ul');
   list.id = select.id + '-List';
   list.className = 'mnfc-combo-list';
   list.setAttribute('role', 'listbox');
   row.querySelector('label').id = input.id + '-Label';
   list.setAttribute('aria-labelledby', input.id + '-Label');
   input.setAttribute('aria-controls', list.id);
   list.hidden = true;
   field.appendChild(list);
   const toggle = document.createElement('button');
   toggle.type = 'button';
   toggle.tabIndex = -1;
   toggle.className = 'mnfc-combo-toggle';
   toggle.setAttribute('aria-label', root.dataset.nfcToggle);
   toggle.setAttribute('aria-controls', list.id);
   toggle.textContent = '⌄';
   field.insertBefore(toggle, list);
   const nativeLabel = root.querySelector('label[for="' + select.id + '"]');
   let matches = options.slice();
   let active = -1;
   let optionPress = null;
   let ignoreOptionClick = false;
   function close() {
    optionPress = null;
    list.hidden = true;
    input.setAttribute('aria-expanded', 'false');
    input.removeAttribute('aria-activedescendant');
    active = -1;
   }
   function choose(item, fromPointer) {
    select.value = item.value;
    input.value = item.text;
    input.setAttribute('aria-invalid', 'false');
    select.dispatchEvent(new Event('change', {bubbles:true}));
    close();
    empty.hidden = true;
    if (fromPointer) input.blur();
   }
   function render(query) {
    matches = matchMomentPhoneOptions(options, query);
    active = -1;
    input.removeAttribute('aria-activedescendant');
    list.replaceChildren();
    matches.forEach(function(item) {
     const wrapper = document.createElement('li');
     wrapper.setAttribute('role', 'presentation');
     const node = document.createElement('button');
     node.type = 'button';
     node.tabIndex = -1;
     node.id = select.id + '-Option-' + item.index;
     node.setAttribute('role', 'option');
     node.setAttribute('aria-selected', item.value === select.value ? 'true' : 'false');
     node.textContent = item.text;
     node.addEventListener('pointerdown', function(event) {
      if (event.isPrimary === false || (event.button !== undefined && event.button !== 0)) return;
      ignoreOptionClick = false;
      optionPress = {id:event.pointerId, x:event.clientX, y:event.clientY, value:item.value, moved:false};
      if (event.pointerType === 'mouse') event.preventDefault();
     });
     node.addEventListener('pointermove', function(event) {
      if (!optionPress || optionPress.id !== event.pointerId) return;
      if (Math.hypot(event.clientX - optionPress.x, event.clientY - optionPress.y) > 10) optionPress.moved = true;
     });
     node.addEventListener('pointercancel', function() { optionPress = null; ignoreOptionClick = true; });
     node.addEventListener('pointerup', function(event) {
      const press = optionPress;
      optionPress = null;
      if (!press || press.id !== event.pointerId || press.value !== item.value || list.hidden) return;
      const moved = press.moved || Math.hypot(event.clientX - press.x, event.clientY - press.y) > 10;
      ignoreOptionClick = moved;
      if (event.pointerType !== 'mouse' && !moved) {
       event.preventDefault();
       choose(item, true);
      }
     });
     node.addEventListener('click', function(event) {
      event.preventDefault();
      if (ignoreOptionClick && event.detail !== 0) { ignoreOptionClick = false; return; }
      ignoreOptionClick = false;
      if (list.hidden) return;
      choose(item, true);
     });
     wrapper.appendChild(node);
     list.appendChild(wrapper);
    });
    count.textContent = String(matches.length);
    empty.hidden = matches.length > 0;
    list.hidden = matches.length === 0;
    input.setAttribute('aria-expanded', matches.length ? 'true' : 'false');
   }
   function highlight(index) {
    active = Math.max(0, Math.min(matches.length - 1, index));
    Array.from(list.querySelectorAll('[role="option"]')).forEach(function(node, i) {
     node.setAttribute('aria-selected', i === active ? 'true' : 'false');
     if (i === active) {
      input.setAttribute('aria-activedescendant', node.id);
      node.scrollIntoView({block:'nearest'});
     }
    });
   }
   input.addEventListener('focus', function() { render(select.value ? '' : input.value); });
   input.addEventListener('click', function() {
    if (list.hidden) render(select.value ? '' : input.value);
   });
   input.addEventListener('input', function() {
    select.value = '';
    select.dispatchEvent(new Event('change', {bubbles:true}));
    input.removeAttribute('aria-invalid');
    render(input.value);
   });
   input.addEventListener('keydown', function(event) {
    if (event.isComposing) return;
    if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
     event.preventDefault();
     if (list.hidden) render(select.value ? '' : input.value);
     if (matches.length) highlight(active < 0 ? (event.key === 'ArrowDown' ? 0 : matches.length - 1) : active + (event.key === 'ArrowDown' ? 1 : -1));
    } else if (event.key === 'Enter' && !list.hidden) {
     event.preventDefault();
     if (active >= 0) choose(matches[active]);
     else if (matches.length === 1) choose(matches[0]);
    } else if (event.key === 'Escape') {
     if (!list.hidden) event.preventDefault();
     close();
    } else if (event.key === 'Tab') {
     close();
    }
   });
   toggle.addEventListener('pointerdown', function(event) { event.preventDefault(); });
   toggle.addEventListener('click', function() {
    if (!list.hidden) close();
    else { input.focus(); render(select.value ? '' : input.value); }
   });
   row.addEventListener('focusout', function(event) {
    if (!optionPress && !row.contains(event.relatedTarget)) close();
   });
   combos.push({field:field, close:close, release:function(event) {
    if (!optionPress || optionPress.id !== event.pointerId) return;
    optionPress = null;
    if (!field.contains(event.target)) close();
   }});
   root.addEventListener('moment:nfc-close', close);
   select.hidden = true;
   if (nativeLabel) nativeLabel.hidden = true;
   row.hidden = false;
   count.textContent = String(options.length);
  });
  guide.querySelectorAll('a[href="#nfc-assistenza"]').forEach(function(link) {
   link.addEventListener('click', function() {
    const help = guide.querySelector('#nfc-assistenza');
    if (help) help.open = true;
   });
  });
 });
}
initMomentPhoneHierarchy(document);
document.addEventListener('shopify:section:load', function(event) { initMomentPhoneHierarchy(event.target); });


  } catch(e) { console.error(e); }
})();
})();
